import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import { ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
import { createPersonalizationSearchString } from 'personalization-lib/utils/urls/queryParams';
import { getFeatureGates } from 'personalization-lib/utils/auth/featureAccess';
const getAssetEditorBaseUrl = ({
  source,
  id
}) => {
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return getFeatureGates().ctaV2Editor ? `/calls-to-action/${PortalIdParser.get()}/v2-editor/${id}` : `/calls-to-action/${PortalIdParser.get()}/edit/${id}`;
    case ASSET_TYPES.LANDING_PAGE:
    case ASSET_TYPES.WEBSITE_PAGE:
      return `/pages/${PortalIdParser.get()}/editor/${id}`;
    default:
      return '';
  }
};
export const getAssetEditorUrl = ({
  source,
  id
}, {
  search = ''
} = {}) => {
  const baseUrl = getAssetEditorBaseUrl({
    source,
    id
  });
  return baseUrl && `${baseUrl}/content${search}`;
};
export const getAssetPreviewUrl = ({
  source,
  id
}, strategyId) => {
  const search = createPersonalizationSearchString({
    strategyId
  });
  const baseUrl = getAssetEditorBaseUrl({
    source,
    id
  });
  return baseUrl && `${baseUrl}/preview${search}`;
};
export const getAssetDetailsUrl = ({
  source,
  id
}, strategyId) => {
  const search = createPersonalizationSearchString({
    strategyId
  });
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/details/${id}/performance${search}`;
    case ASSET_TYPES.LANDING_PAGE:
      return `/page-details/${PortalIdParser.get()}/landing-page/${id}/performance${search}`;
    case ASSET_TYPES.WEBSITE_PAGE:
      return `/page-details/${PortalIdParser.get()}/site-page/${id}/performance${search}`;
    default:
      return '';
  }
};
export const getAssetListUrl = assetType => {
  switch (assetType) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}`;
    case ASSET_TYPES.LANDING_PAGE:
      return `/page-ui/${PortalIdParser.get()}/management/pages/landing/`;
    case ASSET_TYPES.WEBSITE_PAGE:
      return `/page-ui/${PortalIdParser.get()}/management/pages/site/`;
    default:
      return '';
  }
};
export const getAssetCreateUrl = assetType => {
  switch (assetType) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/create`;
    case ASSET_TYPES.LANDING_PAGE:
      {
        const queryParams = {
          referrer: 'personalization',
          referrerUrl: window.location.href
        };
        return `/page-creation/${PortalIdParser.get()}/create-page/landing-page/template?${stringify(queryParams)}`;
      }
    case ASSET_TYPES.WEBSITE_PAGE:
      {
        const queryParams = {
          referrer: 'personalization',
          referrerUrl: window.location.href
        };
        return `/active-theme-create/${PortalIdParser.get()}/create-page/site-page/select-template?${stringify(queryParams)}`;
      }
    default:
      return '';
  }
};